import axios from 'axios'
import { ElMessage } from 'element-plus'

const api_config=  {
    baseURL: "https://scavcdownload.yidaimingjvn.xyz/get/",
    // baseURL: "http://localhost:9999/get/",
    timeout: 50000
}
const API = axios.create(
    api_config
)

// 请求拦截器
API.interceptors.request.use(
    function (config) {
        return config
    },
    function (error) {
        // 对请求错误做些什么
        if(error.message == "timeout of 50000ms exceeded"){
            ElMessage.error("请求超时！")
        }else{
            ElMessage.error(error.message)
        }
        
        // location.href="/"
        return Promise.reject(error);
    }
)

// 响应拦截器
API.interceptors.response.use(
    function (response) {

        return response;
    }, 
    function (error) {
        // 超出 2xx 范围的状态码都会触发该函数。
        // 对响应错误做点什么
        if(error.message == "timeout of 50000ms exceeded"){
            ElMessage.error("请求超时！")
        }else{
            ElMessage.error(error.message)
        }
        // location.href="/"
        return Promise.reject(error);
    }
)

export default API